import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { brands } from '../data/brands';
import './BrandDetail.css';

const BrandDetail = () => {
  const { id } = useParams();
  const { t } = useLanguage();
  const brand = brands.find(b => b.id === id);
  const [heroImageError, setHeroImageError] = useState(false);

  console.log('Brand details:', {
    id,
    heroImage: brand?.heroImage,
    image: brand?.image,
    usingFallback: heroImageError
  });

  if (!brand) {
    return (
      <div className="brand-detail-container">
        <div className="brand-not-found">
          <h2>{t('brandNotFound', 'Brand niet gevonden')}</h2>
          <Link to="/brands" className="back-to-brands">
            {t('backToBrands', 'Terug naar Merken')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="brand-detail-container">
      <Link to="/brands" className="back-to-brands">
        ← {t('backToBrands', 'Terug naar Merken')}
      </Link>
      
      <div className="brand-detail-header">
        <div 
          className="brand-detail-image"
          style={{
            backgroundImage: `url(${brand.heroImage || brand.image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
        <img 
          src={brand.logo || brand.image} 
          alt={brand.name}
          className="brand-detail-logo"
        />
        {brand.subTitle && (
          <div className="brand-detail-subtitle">
            {brand.subTitle}
          </div>
        )}
      </div>

      <div className="brand-detail-stats">
        {brand.brandReach && (
          <div className="brand-stat-item">
            <span className="brand-stat-label">{t('brandReach', 'Bereik')}</span>
            <span className="brand-stat-value">{brand.brandReach}</span>
          </div>
        )}
        {brand.brandPageviews && (
          <div className="brand-stat-item">
            <span className="brand-stat-label">{t('brandPageviews', 'Paginaweergaven')}</span>
            <span className="brand-stat-value">{brand.brandPageviews}</span>
          </div>
        )}
        {brand.brandReachRegion && (
          <div className="brand-stat-item">
            <span className="brand-stat-label">{t('brandReachRegion', 'Regionaal bereik')}</span>
            <span className="brand-stat-value">{brand.brandReachRegion}</span>
          </div>
        )}
        {brand.brandReadIntensity && (
          <div className="brand-stat-item">
            <span className="brand-stat-label">{t('brandReadIntensity', 'Leesintensiteit')}</span>
            <span className="brand-stat-value">{brand.brandReadIntensity}</span>
          </div>
        )}
        {brand.brandReachSocialFollowers && (
          <div className="brand-stat-item">
            <span className="brand-stat-label">{t('brandReachSocialFollowers', 'Social volgers')}</span>
            <span className="brand-stat-value">{brand.brandReachSocialFollowers}</span>
          </div>
        )}
      </div>

      <div className="brand-detail-content">
        <h1 className="brand-detail-name">{brand.name}</h1>
        <p className="brand-detail-description" dangerouslySetInnerHTML={{ __html: brand.description }}></p>

        <div className="brand-detail-info">
          {brand.region && (
            <div className="brand-detail-item">
              <strong>{t('region', 'Regio')}:</strong>
              {brand.region}
            </div>
          )}
          {brand.type && (
            <div className="brand-detail-item">
              <strong>{t('type', 'Type')}:</strong>
              {t(brand.type, brand.type)}
            </div>
          )}
          {brand.website && (
            <a 
              href={brand.website}
              target="_blank"
              rel="noopener noreferrer"
              className="brand-detail-website"
            >
              {t('visitWebsite', 'Bezoek Website')}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default BrandDetail; 